import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-files-download-icon',
  templateUrl: './files-download.component.html'
})
export class FilesDownloadComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
